module.exports = __webpack_public_path__ + "static/img/about1.ed47f76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about1.png
// module id = k/zg
// module chunks = 1